<div class="cf-brand" [class.classic-header]="isLocalHeader" [style.display]="isLocalHeader ? 'flex' : 'none'">
  <div class="cf-phone chat-button-group" *ngIf="mobile">
    <div id="header-cbg-chat" class="cf-chat chat-button no-agents">
      <span class="chat-button__label">Chat</span>
    </div>
    <a id="header-cbg-call" class="cf-call" (click)="mobilePhoneTracking()" href="tel:{{ mobilePhoneNum }}">Call us</a>
  </div>

  <div class="cf-logo">
    <img src="assets/img/logos/m-legalzoom-logo.svg" alt="LegalZoom" (click)="goHomepage()" />
  </div>

  <div class="cf-phone" *ngIf="!mobile">
    <span class="fa fa-phone phone-icon"></span>
    <span class="phone-number">{{ deskPhoneNum }}</span>
  </div>

  <div *ngIf="userHasCart()" class="cf-action">
    <span *ngIf="isGuest()">
      <a id="lnk-save-progress" *ngIf="mobile" [routerLink]="" (click)="saveYourWork()">Save&nbsp;Progress</a>
      <a id="lnk-save-progress" *ngIf="!mobile" [routerLink]="" (click)="saveYourWork()">Save your progress</a>
    </span>
    <span *ngIf="!isGuest()">
      <a id="lnk-logout" [routerLink]="" (click)="logout()">Log out</a>
    </span>
  </div>
</div>
<gc-header [class.gc-header-visible]="!isLocalHeader" [class.gc-header-invisible]="isLocalHeader"></gc-header>